import React from 'react'
import PropTypes from 'prop-types'
import { View } from 'components/View'
import ContentBox from 'components/ContentBox'
import TextTitleCompressedHeavy from 'components/TextTitleCompressedHeavy'
import TextBodySmaller from 'components/TextBodySmaller'
import ButtonPrimary from 'components/ButtonPrimary'
import ButtonLoader from 'components/ButtonLoader'
import Video from 'components/Video'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import { useTheme } from 'modules/styles'

const messages = defineMessages({
  checkYourForm: {
    id: 'UploadVideoSection.checkYourForm',
    defaultMessage: 'Check Your Form'
  },
  uploadVideo: {
    id: 'UploadVideoSection.uploadVideo',
    defaultMessage: 'Upload Video'
  },
  chooseAnotherVideo: {
    id: 'UploadVideoSection.chooseAnotherVideo',
    defaultMessage: 'Choose Another Video'
  },
  maxDuration: {
    id: 'UploadVideoSection.maxDuration',
    defaultMessage: 'Maximum duration: 20 seconds'
  },
  submit: {
    id: 'UploadVideoSection.submit',
    defaultMessage: 'Analyze Form'
  }
})

export const UploadVideoSection = ({
  selectedFile,
  previewVideoUrl,
  videoInputRef,
  isUploadingVideo,
  isAnalyzingForm,
  loadingLabel,
  onUploadClick,
  onFileChange,
  onSubmit
}) => {
  const intl = useIntl()
  const theme = useTheme()

  return (
    <>
      <ContentBox
        mb={2}
        ac
        style={{
          border: `2px dashed ${theme.colors.border}`,
          backgroundColor: theme.colors.backgroundContent
        }}
      >
        <View mb={2}>
          <TextTitleCompressedHeavy>
            {selectedFile ? selectedFile.name : formatMessageIntlUtil(intl, messages.checkYourForm)}
          </TextTitleCompressedHeavy>
        </View>

        <View mb={3}>
          <TextBodySmaller
            style={{ color: theme.colors.paragraph }}
          >
            {formatMessageIntlUtil(intl, messages.maxDuration)}
          </TextBodySmaller>
        </View>

        {/* Preview Video */}
        {previewVideoUrl && (
          <View
            mb={3}
            w
          >
            <Video
              width='100%'
              source={previewVideoUrl}
              key={previewVideoUrl}
            />
          </View>
        )}

        <input
          ref={videoInputRef}
          type='file'
          accept='video/mp4,.mp4'
          onChange={onFileChange}
          style={{ display: 'none' }}
        />

        <View
          style={{
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <ButtonPrimary
            onClick={onUploadClick}
            isDisabled={isUploadingVideo || isAnalyzingForm}
            style={{
              width: '100%',
              maxWidth: 'unset'
            }}
          >
            {selectedFile
              ? formatMessageIntlUtil(intl, messages.chooseAnotherVideo)
              : formatMessageIntlUtil(intl, messages.uploadVideo)}
          </ButtonPrimary>
        </View>
      </ContentBox>

      {/* Submit Button */}
      {selectedFile && (
        <View
          style={{ textAlign: 'center' }}
          mb={2}
        >
          <ButtonLoader
            onClick={onSubmit}
            isLoading={isUploadingVideo || isAnalyzingForm}
            loadingLabel={loadingLabel}
            style={{
              width: '100%',
              maxWidth: 'unset'
            }}
          >
            {formatMessageIntlUtil(intl, messages.submit)}
          </ButtonLoader>
        </View>
      )}
    </>
  )
}

UploadVideoSection.propTypes = {
  selectedFile: PropTypes.object,
  previewVideoUrl: PropTypes.string,
  videoInputRef: PropTypes.object.isRequired,
  isUploadingVideo: PropTypes.bool.isRequired,
  isAnalyzingForm: PropTypes.bool.isRequired,
  loadingLabel: PropTypes.string,
  onUploadClick: PropTypes.func.isRequired,
  onFileChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
}
